module.exports = __webpack_public_path__ + "img/hr-heat-pipe-t-left-1.54e4056e.png";